
import Vue from "vue";
import AppSaleTypeSelect from "@/components/sales/SaleTypeSelect.vue";
import { View } from "@/models/view";
import { BrowseID } from "@/models/browse";

export default Vue.extend({
	props: {
		view: {
			type: Object as ()=>View,
			required: true
		}
	},
	computed: {
		contactGroupId():number{
			if (this.view.BrowseID == BrowseID.PURCHASE_DOCUMENTS){
				return 2;
			}
			if (this.view.BrowseID == BrowseID.PROSPECT_DOCUMENTS){
				return 3;
			}
			return 1;
		}
	},
	methods: {
		setDefaultNewSaleTypeID(value:number){
			this.view.MetaData.NewSaleTypeID = value;
		}
	},
	components: {
		AppSaleTypeSelect
	},
	i18nEx: {
		componentPrefix: "components.view-editor"
	}
});
